import { DialogV2 } from "components/v2"
import { useState, useEffect } from "react"
import { LibraryTemplateResponse } from "types/Redux"
import { PreviewCPElement } from "../common"
import { TFunction } from "i18next"

interface PreviewElementModalProps {
    isOpened: boolean
    onClose: () => void
    t: TFunction
    list: LibraryTemplateResponse[]
    cpElement: any
}

const PreviewElementModal: React.FC<PreviewElementModalProps> = ({ isOpened, onClose, t, list, cpElement }) => {
    const [selectedElement, setSelectedElement] = useState<LibraryTemplateResponse | null>(null)

    const getSelectedElementId = () => {
        if (!cpElement) return null
        return (
            cpElement?.questionnaire_element_library_template_id ||
            cpElement?.exercise_element_library_template_id ||
            cpElement?.unit_element_library_template_id ||
            null
        )
    }

    useEffect(() => {
        setSelectedElement(list?.find((el) => el.id === getSelectedElementId()))
    }, [cpElement, list])

    return (
        <DialogV2
            title={t("preview")}
            classList={{
                title: "w-[1200px]"
            }}
            isOpen={isOpened}
            onClose={onClose}
            backType="light-gray"
            onDismiss={onClose}
            dismissType="light-gray"
            type="wide"
        >
            <div className="h-[677px] overflow-y-auto w-full">
                <PreviewCPElement libraryElement={selectedElement} />
            </div>
        </DialogV2>
    )
}

export default PreviewElementModal
